import { anatomy } from '@zag-js/date-picker';
export const datePickerAnatomy = anatomy.extendWith('view');
